<div class="w-full">
<!-- 明細編輯開始 class="mat-dialog-container"  -->
<div #head class="w-full">
  <app-modal-header #modal_header class="w-full" [isDialog]="isDialog" [title]="title" [state]="state" (onOkClick)="doOk($event)"
    (onCancelClick)="doCancel($event)">
  </app-modal-header>
</div>
<div class="jk-content w-full" >
  <div class="jk-grid-cols-2">
    <div>
      <app-jktextarea label="內文" [displayLabel]="true" [(value)]="item.WL004"
        height="300px" [readOnly]="true" [maxlength]="1000">
      </app-jktextarea>
    </div>
    <div>
      <app-jkedit  label="格式" #WL012Com  id="WL012"  [(value)]="item.WL012" placeholder="格式"  [readonly]="isBrowse"     >
      </app-jkedit>
      <app-quill-html [html]="item.WL013"
        (htmlChange)="srv.htmlChange($event)" (textChange)="srv.textChange($event)">
      </app-quill-html>

    </div>
  </div>
  <div class="jk-grid-cols-3">
    <div>
      <app-jktextarea class="jk-textarea-border" label="主旨" id="WL007" height="100px" [readOnly]="false"
        [maxlength]="100" [(value)]="item.WL007">
      </app-jktextarea>
      <app-jkstarmark [isUpdate]="false" (click)="srv.toggleStar(item)" [value]="item.WL008">
      </app-jkstarmark>
    </div>
    <div>
      <div (click)="srv.toggleTag(item,false)">{{showTag(item.WL011)}}</div>
      <app-jkcheckboxYN  label="tag" #WL011Com  id="WL011"  [(valueYN)]="item.WL011"  [readonly]="isBrowse"     >
      </app-jkcheckboxYN>
    </div>
    <div>
      <app-jkdatefield label="日期" [type]="'date'" [(value)]="item.WL005" ></app-jkdatefield>
    </div>
  </div>
  <div class="jk-grid-cols-3">
    <div>
      <app-jkdatefield  label="Date" #WL006Com  id="WL006"  [(date)]="item.WL006" placeholder="Date"  [readonly]="isBrowse"

      >
    </app-jkdatefield>
    </div>
    <div>
      <app-jknumberedit label="排序" dataType="number" [(value)]="item.WL003"></app-jknumberedit>
    </div>
    <div>
      <app-jkbtnedit [label]="'股票/商品代號'" [maintable]="'STKMA'" [item]="'W01'" [(value)]="item.WL010"
      [valueExpr]="'MA001'" [displayExpr]="'MA002'"
      ></app-jkbtnedit>
  </div>
    <div>
      <app-jkedit [(value)]="item.WL002" labelMode="floating" label="序號" [required]="true">
      </app-jkedit>
    </div>
  </div>
  <div class="jk-grid-cols-4">
    <div>
    </div>
      <app-jkedit [(value)]="item.WL001" labelMode="floating" label="單號">
      </app-jkedit>
    <div>
      <app-jkedit [(value)]="item.CREATE_DATE" labelMode="floating" label="建立日期" [showClearButton]="true">
      </app-jkedit>
    </div>
    <div>
      <app-jkedit [(value)]="item.WL009" labelMode="floating" label="來源單號">
      </app-jkedit>
    </div>
    <div>
    </div>
  </div>

</div>
</div>
